import { makeStyles } from 'tss-react/mui';
import { brandColors } from '@/styles/theme/values/brandColors';

const useStyles = makeStyles({
  name: 'ProductCatalogList',
})(({ spacing, aspectRatio, typography, breakpoints }) => ({
  spacingContainer: {
    background: brandColors.tintsOffWhite60,
    paddingBottom: spacing(3),
    paddingTop: spacing(3),
    [breakpoints.up('md')]: {
      padding: spacing(1),
    },
  },
  cardWrapper: {
    marginTop: spacing(3),
  },
  heading: {
    marginBottom: spacing(0),
  },
  productCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  productImageWrapper: {
    display: 'flex',
    overflow: 'hidden',
    borderRadius: typography.pxToRem(16),
    aspectRatio: aspectRatio['1/1'],

    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['4/3'],
    },
  },
  productImage: {
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
    transition: 'transform 0.3s ease-in-out',

    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(1),
  },
  productTitle: {
    cursor: 'pointer',
    marginBottom: spacing(-1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    textDecoration: 'none',
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  productPrice: {
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
  },
}));

export default useStyles;
